import getCollection from './getCollection';

export default async function getExportTemplates() {
    return getCollection('exportTemplates');
}
